import * as React from "react";
import styled from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
const Content = styled("div") `
  padding: ${(props) => typeof props.paddingtb === "undefined" ? 20 : props.paddingtb}px ${(props) => typeof props.paddinglr === "undefined" ? 20 : props.paddinglr}px;
  border-bottom: 1px solid ${(props) => props.theme.box.border};
  &:last-child {
    border-bottom: none;
  }
`;
export const ModalContent = (props) => React.createElement(Content, Object.assign({}, props), props.children);
export const ModalTitle = styled("div") `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => typeof props.paddingtb === "undefined" ? 20 : props.paddingtb}px ${(props) => typeof props.paddinglr === "undefined" ? 20 : props.paddinglr}px;
  background: ${({ theme, level }) => level === 2 ? shadeAlternate(0.08, theme.box.background) : shadeAlternate(0.03, theme.box.background)};
  border-bottom: 1px solid ${(props) => props.theme.box.border};
`;
//# sourceMappingURL=content.js.map